import { PrismaClient } from '@prisma/client'
import { betterAuth } from 'better-auth'
import { prismaAdapter } from 'better-auth/adapters/prisma'
import { nextCookies } from 'better-auth/next-js'
import { admin } from 'better-auth/plugins'
import { sendEmailRegistration } from '../actions'

const prisma = new PrismaClient()

export const auth = betterAuth({
  appName: 'Axolmen',
  secret: process.env.BETTER_AUTH_SECRET || 'KHiNjcPUr9RBYGmcB8EVjAE3doh4sArP',
  database: prismaAdapter(prisma, {
    provider: 'postgresql'
  }),

  databaseHooks: {
    user: {
      create: {
        after: async (user) => {
          await sendEmailRegistration(user.email, user.name)
        }
      }
    }
  },

  plugins: [
    nextCookies(),
    admin({
      defaultRole: 'user',
      adminRole: ['admin', 'superAdmin'],
      impersonationSessionDuration: 60 * 60 * 24
    })
  ],

  trustedOrigins: ['http://localhost:3000', 'https://www.axolmen.com'],

  socialProviders: {
    google: {
      clientId: process.env.AUTH_GOOGLE_ID || '',
      clientSecret: process.env.AUTH_GOOGLE_SECRET || ''
    }
  },
  session: {
    expiresIn: 60 * 60 * 24 * 7, // 7 days
    updateAge: 60 * 60 * 24 // 1 day (every 1 day the session expiration is updated)
  }
})
